export const MAX_CONTEXT_MESSAGES = 50;
export const COPY_FEEDBACK_TIMEOUT_MS = 2000;
export const CHATBOT_STORAGE_PREFIX = "restaurant-chatbot-widget";
export const FALLBACK_STORAGE_USER_ID = "current";
export const WELCOME_MESSAGE_TRANSLATION_KEY = "chatbot_welcome_message";
export const EMPTY_RESPONSE_TRANSLATION_KEY = "chatbot_empty_response";
export const ERROR_MESSAGE_TRANSLATION_KEY = "chatbot_error_message";
export const USAGE_LIMIT_REACHED_TRANSLATION_KEY = "chatbot_usage_limit_reached";
export const USAGE_LIMIT_RESETS_INTRO_TRANSLATION_KEY = "chatbot_usage_limit_resets_intro";
export const USAGE_LIMIT_RESET_LINE_TRANSLATION_KEY = "chatbot_usage_limit_reset_line";
export const USAGE_LIMIT_WINDOW_PREFIX_TRANSLATION_KEY = "chatbot_usage_limit_window";
export const USER_ROLE = "user";
export const ASSISTANT_ROLE = "assistant";
export const ABORT_ERROR_NAME = "AbortError";
export const SESSION_LIST_PAGE = 1;
export const SESSION_LIST_PAGE_SIZE = 20;
export const MAX_REFERENCE_IMAGE_DIMENSION = 2400;
export const COMPRESSED_IMAGE_TYPE = "image/webp";
export const INITIAL_COMPRESSION_QUALITY = 0.88;
export const HTTP_STATUS_TOO_MANY_REQUESTS = 429;
export const HTTP_STATUS_FORBIDDEN = 403;
